import Tags from "./tags/Tags";
import Related from "./related-posts/Related";
import style from "./block.module.scss";
import { defineBlock } from "@smartfire/js-block-engine";

function Block({ tags, related }) {
  return (
    <div className={style.block}>
      {tags && (
        <>
          <Tags tags={tags} />
          <div className={style.separator} />
        </>
      )}
      <Related posts={related} />
    </div>
  );
}

export default defineBlock({
  Block: Block,
});
